import { Fragment, useCallback, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { HttpResponse } from 'shell/models/http-response';
import { ResponseAnprData } from 'shell/models/person';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { __PERSON_NEW_API_URL__ } from 'shell/constants/environment';
import { DetailCohabitationCrumbs } from 'cohabitation/constants/breadcrumb';
import { transformerCohabitation } from 'cohabitation/utils/transformer-cohabitation';
import { CohabitationDetailForm } from 'cohabitation/view-models/detail-cohabitation';
import { Box, Grid } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import CohabitationDetailStep from 'cohabitation/components/detail/child';
import CohabitationDetailPageButtons from 'cohabitation/components/detail/buttons';
import { Form, Formik } from 'formik';
import { noop } from 'shell/utils/noop';
import { cohabitationFormSchema } from 'cohabitation/constants/validation-schema-detail';

const CohabitatonDetailPage = (): React.ReactElement => {
  const [queryParams] = useSearchParams();
  const navigate = useNavigate();

  // query params
  const nationalSearch = JSON.parse(queryParams.get('ricercaNazionale') || 'false');
  const anprId = queryParams.get('anprId') || '';

  const [anpr] = useHttpFetch<HttpResponse<ResponseAnprData>, CohabitationDetailForm>(
    `${__PERSON_NEW_API_URL__}/persona`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'POST',
        loading: true,
        data: {
          criteriRicerca: {
            identificativoANPR: anprId,
            tipoScheda: '2',
          },
          datiRichiesta: {
            ricercaNazionale: nationalSearch ? '1' : '0',
          },
        },
      },
      transformer: transformerCohabitation,
    }
  );

  const [stepState, setStepState] = useState<number>(0);

  const handleStep = useCallback(
    (step) => {
      setStepState(step);
    },
    [setStepState]
  );

  const handleExit = useCallback(() => {
    navigate('/convivenza/ricerca');
  }, [navigate]);

  return (
    <Fragment>
      <Breadcrumbs items={DetailCohabitationCrumbs} />
      {anpr.isLoading || anpr.pristine || anpr.hasErrors ? undefined : (
        <Formik
          initialValues={anpr.data as CohabitationDetailForm}
          validationSchema={cohabitationFormSchema}
          validateOnMount
          onSubmit={noop}
        >
          <Form>
            <Grid container spacing={2}>
              <Grid item xs={12} md={2}>
                <CohabitationDetailPageButtons stepState={stepState} handleStep={handleStep} />
                <div className="pmi-pt-4">
                  <div className="pmi-pb-2">
                    <PmiButton
                      color="cdmBrand"
                      variant="contained"
                      fullWidth
                      onClick={handleExit}
                      id="deny-operation"
                    >
                      <Box
                        sx={{
                          textOverflow: 'ellipsis',
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Annulla Operazione
                      </Box>
                    </PmiButton>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} md={10}>
                <Grid container spacing={2} item xs={12}>
                  <Grid item xs={12}>
                    <CohabitationDetailStep stepState={stepState} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Form>
        </Formik>
      )}
    </Fragment>
  );
};

CohabitatonDetailPage.displayName = 'Cohabitation Detail page component';

export default CohabitatonDetailPage;
